export const getRecursionDetectionPlugin = (options) => ({
    applyToStack: (clientStack) => { },
});
